import React, { useState } from "react";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { GiHamburgerMenu } from "react-icons/gi";

import offerIcon from "../assets/Icons/Offere.webp";
import cityIcon from "../assets/Icons/City.webp";
import location from "../assets/Icons/Location.webp";
import service from "../assets/Icons/Services.webp";
import staff from "../assets/Icons/Staff.webp";
import staffIcon from "../assets/Icons/Income.webp";
import RidesIcon from "../assets/Icons/Rides.webp";
import { useNavigate } from "react-router-dom";

const tabs = [
  { id: "fares", label: "Fares",icon: RidesIcon},
  // { id: "city", label: "City", icon: cityIcon },
  // { id: "location", label: "Location", icon: location },
 // { id: "services", label: "Services", icon: service },
  //{ id: "staff", label: "Staff", icon: staff },
  { id: "offers", label: "Offers", icon: offerIcon },
  { id: "income", label: "Income", icon: staffIcon },
  { id: "rides", label: "Rides", icon: RidesIcon },
    { id: "driver", label: "Driver",icon: RidesIcon}
];

const Sidebar = ({ activeTab, setActiveTab }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate=useNavigate()
const onLogoutuser=()=>{
    localStorage.clear();
navigate("/login")
}

  return (
    <>
      {/* Mobile Topbar */}
      <div className="sm:hidden flex justify-between items-center bg-white px-4 py-3 shadow-md fixed top-0 left-0 right-0 z-50">
        <div className="text-xl font-bold text-black">Cab-G</div>
       <button onClick={() => setIsOpen(!isOpen)} className="text-black">
  <GiHamburgerMenu size={24} />
</button>

      </div>

      {/* Sidebar */}
      <div
        className={`fixed sm:static top-0 left-0 h-full w-64 bg-black text-white z-50 transform transition-transform duration-300 ease-in-out 
        ${isOpen ? "translate-x-0" : "-translate-x-full"} sm:translate-x-0`}
      >
        <div className="p-4 flex flex-col justify-between ">
          {/* Sidebar Logo */}
          <div className="bg-[#08B10E] h-[60px] text-white font-bold text-xl flex items-center justify-center rounded mb-6">
            Cab-G
          </div>

          {/* Tabs */}
          <ul className="space-y-2 overflow-y-auto">
            {tabs.map((tab) => (
              <li
                key={tab.id}
                onClick={() => {
                  setActiveTab(tab.id);
                  setIsOpen(false); // Close sidebar on mobile
                }}
                className={`flex justify-between items-center px-4 py-2 rounded cursor-pointer transition duration-200 ${
                  activeTab === tab.id
                    ? "border border-white bg-black font-semibold"
                    : "hover:bg-gray-800"
                }`}
              >
                <div className="flex items-center space-x-3">
       <img src={tab.icon} alt={tab.label} className="w-6 h-6 sm:w-5 sm:h-5" />

                  <span className="capitalize text-base sm:text-base">{tab.label}</span>
                </div>
                <MdOutlineKeyboardArrowRight className="w-5 h-5" />
              </li>
            ))}
          </ul>

          {/* Admin Button */}
          <button className="mt-6 bg-white text-black py-2 rounded font-semibold hover:bg-gray-200 transition">
            Admin
          </button>
             {/* Admin Button */}
          <button onClick={onLogoutuser} className="mt-6 bg-white text-black py-2 rounded font-semibold hover:bg-gray-200 transition">
            Logout
          </button>
        </div>
      </div>

      {/* Overlay (mobile only) */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-opacity-40 z-40 sm:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}
    </>
  );
};

export default Sidebar;
